import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { reducer as baseReducers } from '@price-point/application-base';
import reducers from 'shared/reducers';
import components from './index/components';
import createStore from './index/createStore';

function map(route) {
  // const title = route.title ? route.title : 'PricePoint - Pricing Tool';
  return (
  // <DocumentTitle title={title}>
    <Route exact path={route.path} component={route.component} key={route.path} />
    // </DocumentTitle>
  );
}

export default function Index() {
  const storeImpl = createStore(reducers, baseReducers);
  return (
    <Provider store={storeImpl}>
      <BrowserRouter basename="/login">
        <Switch>
          {components.map(map)}
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}
